module.exports = __webpack_public_path__ + "static/media/hebi-logo.31195651.svg";